/** Entity types that support the related-entities drawer (mirrors backend entityRelationsRegistry). */
export const ENTITY_RELATIONS_SUPPORTED_ENTITIES = [
  "addition",
  "alertConfiguration",
  "area",
  "areasGroup",
  "busStation",
  "businessUnit",
  "course",
  "customField",
  "dayGroup",
  "dayType",
  "disableHour",
  "driver",
  "feedback",
  "feedbackSolution",
  "feedbackSubject",
  "fieldType",
  "flight",
  "foodSupplier",
  "incident",
  "incidentType",
  "journey",
  "meal",
  "passenger",
  "passengerType",
  "permission",
  "priceRate",
  "reason",
  "reasonCategory",
  "ride",
  "rideType",
  "role",
  "shift",
  "shiftTemplate",
  "site",
  "station",
  "stationDistance",
  "supplier",
  "supplierPriceRate",
  "systemManager",
  "systemTag",
  "unit",
  "user",
  "vehicle",
  "vehicleType",
  "waitingListPassenger",
] as const;

export const isEntityRelationsSupported = (entity: string): boolean =>
  (ENTITY_RELATIONS_SUPPORTED_ENTITIES as readonly string[]).includes(entity);
